// extracted by mini-css-extract-plugin
export var container = "_8d-0";
export var fallback = "_8d-5";
export var fallbackIcon = "_8d-6";
export var hidden = "_8d-2";
export var image = "_8d-3";
export var loaded = "_8d-4";
export var placeholder = "_8d-1";